import React from 'react';
import { Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { REISSUE_INVOICE } from '../../graphql/mutations/settlement/revenueInvoiceMutations';

interface InvoiceReissueModalProps {
  open: boolean;
  billId: string;
  onCancel: () => void;
  onSuccess: () => void;
}

const InvoiceReissueModal: React.FC<InvoiceReissueModalProps> = ({
  open,
  billId,
  onCancel,
  onSuccess,
}) => {
  const [reissue, { loading }] = useMutation(REISSUE_INVOICE);

  const handleOk = async () => {
    try {
      const res = await reissue({ variables: { billId } });
      const result = res.data?.reissueInvoice;
      if (result?.success) {
        message.success('Invoice 已重开，正在重新生成');
        onSuccess();
      } else {
        message.error(result?.message || 'Invoice 重开失败');
      }
    } catch (e) {
      message.error((e as Error)?.message || 'Invoice 重开失败');
    }
  };

  return (
    <Modal
      open={open}
      title="Invoice 重开"
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      okText="确认重开"
      okButtonProps={{ danger: true }}
      cancelText="取消"
      destroyOnClose
    >
      <div className="flex items-start gap-2">
        <ExclamationCircleOutlined className="text-orange-500 mt-1" />
        <div className="text-sm text-gray-700">
          重开将<strong>作废当前 Invoice</strong>，并<strong>重新聚合费用、重新拉取主体配置</strong>生成新的 Invoice 实例（版本号 +1）。此操作不可撤销，请确认后继续。
        </div>
      </div>
    </Modal>
  );
};

export default InvoiceReissueModal;
